// 搜索相关页面销毁时 需要重置的store数据
export default {
  methods: {
    async getContentTimes () { // 单次曝光选项列表
      if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
      return this.$store.state.bmap.labelTimeSlotList || []
    },
    resetSearchStoreCommon () { // 搜索相关 可能主要影响确认订单相关展示
      this.$store.commit('setStoreData', { key: 'chooseTimeSlot', value: { idx: 0, data: [] } })
      this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: [] }) // 推荐时段

      // 搜索条件相关  清空不会影响其他种类搜索投放 确认订单相关信息展示
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'contentTime'], value: '' })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'time'], value: [] })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'age'], value: [] })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'distType'], value: [] })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'income'], value: [] })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'sex'], value: [] })
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'displayRegion'], value: 1 })

      this.$store.commit('setSearchDetail', []) // 确认订单限制小区相关数据须保存搜索列表的数据，存储在这里

      this.clearLabelPersonStore()
    },
    clearLabelPersonStore () { // 搜索便签相关 store 社区收入 社区类型  用户标签等
      this.$store.commit('label/setStore', { key: [ 'confirm', 'labels' ], value: [] })
      this.$store.commit('label/setStore', { key: [ 'confirm', 'persons' ], value: [] })
      this.$store.commit('label/setStore', { key: [ 'confirm', 'personsData' ], value: [] }) // 用户画像数据
      this.$store.commit('label/setStore', { key: [ 'operate', 'labels' ], value: [] })
      this.$store.commit('label/setStore', { key: [ 'operate', 'persons' ], value: [] })
      this.$store.commit('label/setStore', { key: [ 'operate', 'personsData' ], value: [] }) // 用户画像数据
    },
    profileChange (list) { // 用户画像筛选条件变化相关功能
      // 下面用了 this.order 属性  如果字段名称位其他 可以具体调用 profileChange list => { profileChange(list, keyStr) } 这个方法也增加第二个参数 keyStr
      let fltList = list.filter(el => el.list && el.list.length) // 过滤出有属性的各个用户画像物体
      this.order.originPerson = fltList
      this.order.personsLabels = fltList.map(el => el.list.map(el => el.code))
    },
    handleLabelsParam (condition = {}, nbhdLabels, orderLabels) {
      condition.nbhdLabels = nbhdLabels // 收人水平 社区类型
      condition.orderLabels = orderLabels // 收费方式 预算目标
      return condition
    },
    setStoreSearchForConfirm (conditionData = {}) { // 点击搜索时保存当前搜索数据到store 供确认订单使用
      this.$store.commit('setStoreData', { // 基本搜索
        key: 'mapSearchOptions',
        value: {
          ...conditionData, sex: conditionData.sex ? [conditionData.sex] : [], time: [conditionData.startDate || '', conditionData.endDate || '']
        }
      })
      let { nbhdLabels, orderLabels, personsLabels, originPerson } = conditionData
      this.$store.commit('label/setStore', { key: [ 'confirm', 'labels' ], value: (nbhdLabels || []).concat(orderLabels || []) })
      this.$store.commit('label/setStore', { key: [ 'confirm', 'persons' ], value: personsLabels || [] })
      this.$store.commit('label/setStore', { key: [ 'confirm', 'personsData' ], value: originPerson || [] }) // 用户画像数据
      if (this.$refs.formCmp) { // orderFormPoint 搜索条件 投放时段相关数据保存
        let timeSlotCmp = this.$refs.formCmp.$refs.timeRangeRef
        if (timeSlotCmp) {
          this.$store.commit('setStoreData', { key: ['chooseTimeSlot'], value: timeSlotCmp.dest })
        }
      } else if (this.$refs.formCmpImport) { // 导入投放的  投放时段相关数据保存
        let timeSlotCmp = this.$refs.formCmpImport.$refs.timeRangeRef
        if (timeSlotCmp) {
          this.$store.commit('setStoreData', { key: ['chooseTimeSlot'], value: timeSlotCmp.dest })
        }
      }
    }
  }
}
